module.exports = __webpack_public_path__ + "media/images/add-4c0ab963bd09f34cbe97e24fa47ec681.svg";